import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from '../../hooks/useTranslation';

const QUOTE_KEYS = ['landingPainQuote1', 'landingPainQuote2', 'landingPainQuote3'];

const LandingPainQuotes = () => {
  const { t } = useTranslation();
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % QUOTE_KEYS.length);
    }, 5000);
    return () => window.clearInterval(id);
  }, []);

  const quote = t(QUOTE_KEYS[index]);

  return (
    <section className="py-6 px-4 sm:px-6 border-y border-purple-100/80 bg-gradient-to-r from-violet-50/40 via-white to-violet-50/40">
      <div className="max-w-3xl mx-auto text-center min-h-[3.5rem] flex items-center justify-center">
        <AnimatePresence mode="wait">
          <motion.p
            key={index}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.45, ease: 'easeOut' }}
            className="text-base sm:text-lg text-gray-500 italic leading-relaxed px-2"
          >
            &ldquo;{quote}&rdquo;
          </motion.p>
        </AnimatePresence>
      </div>
    </section>
  );
};

export default LandingPainQuotes;
